export default {
  getProfile: (state) => state.user || {},
  verifyEmail: (state) => state.verifyEmail,
  setPanel: (state) => state.setPanel,
  availablePanels: (state) => state.availablePanels || [],
  userClub: (state) => state.userClub,
  isProfileLoaded: (state) => !!(state.user && state.user.name),
  isSeller: (state) => {
    if (!state.user) return false;

    let roles = state.user.roles;

    if (!roles) {
      return false;
    }

    var isSeller = false;
    roles.forEach(function (role, index) {
      if (role.name === "Seller") {
        isSeller = true;
        return;
      }
    });
    return isSeller;
  },
  isAdmin: (state) => {
    if (!state.user) return false;

    const roles = state.user.roles;
    return Array.isArray(roles) && roles.some((role) => role.name === "Admin");
  },
  isClient: (state) => {
    if (!state.user) return false;

    let roles = state.user.roles;

    if (!roles) {
      return false;
    }

    var isClient = false;
    roles.forEach(function (role, index) {
      if (role.name === "Client") {
        isClient = true;
        return;
      }
    });
    return isClient;
  },
  isClientOnly: (state, getters) => (
    getters.isClient && !getters.isSeller && !getters.isAdmin
  ),
  isPanelAuthorized: (state, getters) => (panelId) => {
    if (!getters.isClientOnly) {
      return true;
    }

    return getters.availablePanels.some((panel) => {
      if (!panel || panel.id == null || String(panel.id) !== String(panelId)) {
        return false;
      }

      const hasSellerRole = Array.isArray(panel.roles) && panel.roles.some(
        (role) => role.name === "Seller" || role.name === "Admin",
      );
      const userId = getters.getProfile && getters.getProfile.id;
      const hasConfirmedRelation = Array.isArray(panel.sub_user_parent)
        && panel.sub_user_parent.some((relation) => (
          String(relation.child_user_id) === String(userId)
          && String(relation.parent_user_id) === String(panel.id)
          && (relation.child_confirmed === true || relation.child_confirmed === 1 || relation.child_confirmed === '1')
          && (relation.parent_confirmed === true || relation.parent_confirmed === 1 || relation.parent_confirmed === '1')
        ));

      return hasSellerRole && hasConfirmedRelation;
    });
  },
};
